export default "__VITE_ASSET__BXOiawg0__"